import loc from 'owa-localize';
import { setPendingMessage } from '../actions/ucmaActions';
import sendMessage from '../chatManager/sendMessage';
import { chatInputDisabled, chatInputPlaceholder } from '../strings.locstring.json';
import notifyTyping from '../services/notifyTyping';
import ChatViewState from '../store/schema/ChatViewState';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';

const NOTIFY_TYPING_STOP_TIMEOUT = 5000;

export interface InputBoxProps {
    linkedChatViewState: ChatViewState;
    isDisabled: boolean;
}

const styles = require('./InputBox.scss');

const styleFixes = {
    root: styles.inputBoxRoot,
    wrapper: styles.inputBoxWrapper,
    fieldGroup: styles.inputBoxFieldGroup,
    field: styles.inputBoxField,
};

export interface InputBoxState {
    multiline: boolean;
}

const MULTILINE_CHARACTER_LIMIT = 35;

@observer
export default class InputBox extends React.Component<InputBoxProps, InputBoxState> {
    private notifyTypingStopTimer: number = 0;

    constructor(props) {
        super(props);
        this.state = {
            multiline: props.linkedChatViewState.pendingMessage.length > MULTILINE_CHARACTER_LIMIT,
        };
    }

    render() {
        const { linkedChatViewState, isDisabled } = this.props;
        return (
            <div className={styles.inputBox}>
                <TextField
                    type="text"
                    value={linkedChatViewState.pendingMessage}
                    onChange={this.onChange}
                    onKeyDown={this.onKeyDown}
                    resizable={false}
                    styles={styleFixes}
                    borderless={true}
                    placeholder={isDisabled ? loc(chatInputDisabled) : loc(chatInputPlaceholder)}
                    multiline={this.state.multiline}
                    disabled={isDisabled}
                />
                {linkedChatViewState.pendingMessage.length > 0 && (
                    <IconButton
                        iconProps={{ iconName: ControlIcons.Send }}
                        onClick={this.onSendMessage}
                    />
                )}
            </div>
        );
    }

    private onChange = (event: React.FormEvent<HTMLInputElement>, newValue: string) => {
        setPendingMessage(this.props.linkedChatViewState, newValue);
        const newMultiline =
            this.props.linkedChatViewState.pendingMessage.length > MULTILINE_CHARACTER_LIMIT;
        if (newMultiline && !this.state.multiline) {
            this.setState({ multiline: newMultiline });
        }
    };

    private onKeyDown = (e: React.KeyboardEvent<unknown>) => {
        if (e.key == 'Enter') {
            if (!e.shiftKey) {
                e.preventDefault();
                this.onSendMessage();
            } else {
                this.setState({ multiline: true });
            }
        } else {
            this.notifyTyping();
        }
    };

    private onSendMessage = () => {
        sendMessage(this.props.linkedChatViewState);
        this.clearTimeout();
        this.setState({ multiline: false });
    };

    private notifyTyping() {
        if (this.notifyTypingStopTimer) {
            this.clearTimeout();
        } else {
            notifyTyping(this.props.linkedChatViewState.sessionId, true /*isTyping*/);
        }
        this.notifyTypingStopTimer = window.setTimeout(
            this.notifyTypingStopped,
            NOTIFY_TYPING_STOP_TIMEOUT
        );
    }

    private notifyTypingStopped = () => {
        const { sessionId } = this.props.linkedChatViewState;
        if (sessionId >= 0) {
            notifyTyping(this.props.linkedChatViewState.sessionId, false /*isTyping*/);
        }
        this.notifyTypingStopTimer = 0;
    };

    private clearTimeout() {
        if (this.notifyTypingStopTimer) {
            window.clearTimeout(this.notifyTypingStopTimer);
            this.notifyTypingStopTimer = 0;
        }
    }
}
